<template>
  <div class="content">
    <div class="main">
      <ScriptShow ref="ScriptShow"></ScriptShow>
      <ScriptExecModal ref="ScriptExecModal" v-on:execComplete="getExecLogs()"></ScriptExecModal>
      <Modal v-model="execLogDetailModal" title="脚本执行结果" :width="800" footer-hide>
        <Alert>
          <div class="exec-logs-detail-c">
            <Row v-if="execLogDetail.datetime">
              <span class="span-dt">开始时间: </span><span>{{ execLogDetail.datetime_format }}</span>
            </Row>
            <Row v-if="execLogDetail.end">
              <span class="span-dt">结束时间: </span><span>{{ execLogDetail.end_format }}</span>
            </Row>
            <Row v-if="execLogDetail.use_time">
              <span class="span-dt">耗时: </span><span>{{ execLogDetail.use_time }}(秒)</span>
            </Row>
            <Row v-if="execLogDetail.user_full_name">
              <span class="span-dt">执行用户: </span><span>{{ execLogDetail.user_full_name }}</span>
            </Row>
            <Row v-if="execLogDetail.version">
              <span class="span-dt">版本: </span><span>{{ execLogDetail.version.version_id }}</span>
              （<a v-on:click="$refs.ScriptShow.openModal(execLogDetail.version)">查看脚本</a>）
            </Row>
            <Row v-if="execLogDetail.params">
              <span class="span-dt">参数: </span><span>{{ execLogDetail.params }}</span>
            </Row>
            <Row v-if="execLogDetail.status">
              <span class="span-dt">状态: </span>
              <span v-if="execLogDetail.status === '队列中'">
                <Icon type="md-clock" size="18" style="color: #2d8cf0" /><span style="color: #2d8cf0">队列中</span>
              </span>
              <span v-if="execLogDetail.status === '完成'">
                <Icon type="md-checkmark" size="18" style="color: #19be6b" /><span style="color: #19be6b">完成</span>
              </span>
              <span v-if="execLogDetail.status === '执行中'">
                <Icon type="ios-loading" size="18" style="color: #ff9900; animation: ani-demo-spin 1s linear infinite" />
                <span style="color: #ff9900">执行中</span>
              </span>
            </Row>
          </div>
        </Alert>
        <div v-if="execLogDetail.result_json">
          <span class="span-dt" style="font-size: 15px">结果: </span>
          <json-viewer
            :value="getJson(execLogDetail.result_json)"
            :expand-depth="3"></json-viewer>
        </div>
      </Modal>
      <div>
        <Row>
          <Col :xs="24" :sm="24" :md="24" :lg="15">
            <div>
              <Row class="title">
                <h4 :style="{float: 'left'}">脚本详情</h4>
                <div :style="{float: 'right'}">
                  <Button type="success" @click="execModalOpen" style="margin-right: 10px">立即执行</Button>
                  <Button type="warning" @click="edit" style="margin-right: 10px">编辑</Button>
                  <Button @click="$router.push({ name: 'script_manage' })">返回</Button>
                </div>
              </Row>
              <Alert v-if="infoError" type="warning" show-icon>获取脚本数据失败</Alert>
              <div class="info-property" v-else>
                <dl>
                  <dt>ID</dt><dd>{{ info.id }}</dd>
                </dl>
                <dl>
                  <dt>脚本名称</dt><dd>{{ info.name }}</dd>
                </dl>
                <dl>
                  <dt>脚本描述</dt><dd>{{ info.desc }}</dd>
                </dl>
                <dl>
                  <dt>脚本类型</dt><dd><Tag color="blue">{{ info.type }}</Tag></dd>
                </dl>
                <dl>
                  <dt>脚本内容</dt>
                  <dd><codemirror ref="detailCm" v-model="info.content" :options="detailCmOptions"></codemirror></dd>
                </dl>
                <dl>
                  <dt>创建用户</dt><dd>{{ info.user_full_name }}</dd>
                </dl>
                <dl>
                  <dt>创建时间</dt><dd>{{ info.datetime_format }}</dd>
                </dl>
                <!--<dl>-->
                  <!--<dt>关联作业数</dt><dd v-if="info.work">{{ info.work.length }}</dd>-->
                <!--</dl>-->
              </div>
            </div>
            <div>
              <Row class="title" :style="{marginTop: '15px'}">
                <h4 :style="{float: 'left'}">执行记录</h4>
                <a v-on:click="getExecLogs()" style="line-height: 32px; padding-left: 10px"><Icon type="md-refresh" size="18"/></a>
              </Row>
              <Row>
                <Alert v-if="execHistory.error" type="warning" show-icon>获取执行记录数据失败</Alert>
                <Table
                  v-else
                  border
                  size="small"
                  :height="tableHeight"
                  :loading="execHistoryLoading"
                  ref="table"
                  :data="execHistory.data"
                  :columns="execHistory.columns"
                  class="mob-remove-table-fixed">
                </Table>
                <div style="margin: 10px 0; overflow: hidden;">
                  <div style="float: right;">
                    <page
                      :total="execHistory.count"
                      :current="execHistory.page"
                      :page-size="execHistory.size"
                      @on-change="getExecLogs"></page>
                  </div>
                </div>
              </Row>
            </div>
          </Col>
          <Col :xs="24" :sm="24" :md="24" :lg="{ span: 8, offset: 1 }">
            <Row class="title" :style="{marginTop: '15px'}">
              <h4 :style="{float: 'left'}">历史版本</h4>
            </Row>
            <Row>
              <Alert v-if="versionHistory.error" type="warning" show-icon>获取版本历史数据失败</Alert>
              <Table
                v-else
                border
                size="small"
                :height="tableHeight"
                ref="versionTable"
                :data="versionHistory.data"
                :columns="versionHistory.columns">
              </Table>
              <div style="margin: 10px 0; overflow: hidden;">
                <div style="float: right;">
                  <page
                    :total="versionHistory.count"
                    :current="versionHistory.page"
                    :page-size="versionHistory.size"
                    @on-change="getVersionHistory"></page>
                </div>
              </div>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import { getContentTypeId, getRevisionLogs, detailScriptExecLogs,
  getScriptExecLogs, detailOpsCenterScript, getScriptVersionHistory } from '@/api/opscenter'
import Logs from './Logs'
import ScriptShow from './script-show'
import ScriptExecModal from './script-exec-modal'
import { scriptTypeChange } from './scriptTools'
import { getJsonFun } from '../../../src/libs/tools'
import codemirror from './scriptUse.js'

export default {
  name: 'script-detail',
  components: {
    Logs,
    ScriptShow,
    codemirror,
    ScriptExecModal
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  data () {
    return {
      contentTypeId: '',
      info: {},
      infoError: false,
      detailCmOptions: {
        mode: {
          name: 'shell'
        },
        lineNumbers: false,
        styleActiveLine: true,
        indentUnit: 4,
        lineWrapping: true,
        theme: 'monokai',
        keyMap: 'sublime',
        smartIndent: false,
        autoRefresh: true,
        autoCloseBrackets: true,
        cursorHeight: 0.85,
        height: '600px',
        readOnly: true,
        showCursorWhenSelecting: true,
        gutters: ['CodeMirror-linenumbers']
      },
      tableHeight: 0,
      execHistory: {
        data: [],
        columns: [
          {
            title: '开始时间',
            key: 'datetime_format',
            align: 'center',
            minWidth: 150
          },
          {
            title: '结束时间',
            key: 'end_format',
            align: 'center',
            minWidth: 150
          },
          {
            title: '耗时(秒)',
            key: 'use_time',
            align: 'center',
            minWidth: 100
          },
          {
            title: '执行用户',
            key: 'user_full_name',
            align: 'center',
            minWidth: 120
          },
          {
            title: '执行状态',
            key: 'status',
            minWidth: 100,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              let iconType = 'md-clock'
              let style = {
                color: '#2d8cf0'
              }
              if (params.row.status === '完成') {
                iconType = 'md-checkmark'
                style.color = '#19be6b'
              } else if (params.row.status === '执行中') {
                iconType = 'ios-loading'
                style.color = '#ff9900'
                style.animation = 'ani-demo-spin 1s linear infinite'
              }
              return h('div', [
                h('Icon', {
                  props: {
                    type: iconType,
                    size: 20
                  },
                  style: style
                }),
                h('span', {
                  style: {
                    color: style.color
                  }
                }, ' ' + params.row.status)
              ])
            }
          },
          {
            title: '操作',
            width: 70,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.getExecLogDetail(params.row.id)
                    }
                  }
                }, '详情')
              ])
            }
          }
        ],
        error: false,
        count: 0,
        page: 1,
        size: 5
      },
      execHistoryLoading: false,
      execLogDetailModal: false,
      execLogDetail: {},
      RevisionLogs: [],
      versionHistory: {
        data: [],
        columns: [
          {
            title: '版本ID',
            align: 'center',
            minWidth: 200,
            key: 'version_id'
          },
          {
            title: '创建用户',
            align: 'center',
            minWidth: 120,
            key: 'user_full_name'
          },
          {
            title: '创建时间',
            align: 'center',
            minWidth: 150,
            key: 'created_format'
          },
          {
            title: '操作',
            width: 70,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$refs.ScriptShow.openModal(params.row)
                    }
                  }
                }, '查看')
              ])
            }
          }
        ],
        error: false,
        count: 0,
        page: 1,
        size: 10
      }
    }
  },
  created: function () {
    this.init()
  },
  computed: {
    myCodeMirror () {
      return this.$refs.detailCm.editor
    }
  },
  methods: {
    // 初始化
    init () {
      this.getData()
      this.listener()
      this.getExecLogs()
      this.getVersionHistory()
      getContentTypeId({ 'model_name': 'Script' }).then(res => {
        let result = res.data
        this.contentTypeId = result.content_type_id
        this.revisionLog()
      }).catch(res => {
        this.$Notice.error({ title: '获取修改记录失败' })
      })
    },
    typeChange (value) {
      const lang = scriptTypeChange(value)
      this.myCodeMirror.setOption('mode', { name: lang })
    },
    // 获取脚本数据
    getData () {
      this.infoError = false
      detailOpsCenterScript(this.$route.params.id).then(res => {
        this.info = res.data
        this.typeChange(this.info.type)
      }).catch(res => {
        this.infoError = true
        this.$Notice.error({ title: '获取脚本数据失败' })
      })
    },
    // 跳转到编辑页
    edit () {
      this.$router.push({
        name: 'script_edit',
        params: { id: this.$route.params.id }
      })
    },
    // 打开执行Modal
    execModalOpen () {
      this.$refs.ScriptExecModal.openModal(this.info)
    },
    // 获取修改记录
    revisionLog () {
      let params = {
        object_id: this.$route.params.id,
        content_type: this.contentTypeId
      }
      getRevisionLogs(params).then(res => {
        this.RevisionLogs = res.data
      }).catch(res => {
        this.$Notice.error({ title: '获取修改记录失败' })
      })
    },
    // 获取脚本执行记录
    getExecLogs (value = 1) {
      this.execHistory.page = value
      let params = {
        size: this.execHistory.size,
        page: this.execHistory.page,
        script: this.$route.params.id
      }
      this.execHistory.error = false
      this.execHistoryLoading = true
      getScriptExecLogs(params).then(res => {
        this.execHistoryLoading = false
        this.execHistory.data = res.data.results
        this.execHistory.count = res.data.count
      }).catch(res => {
        this.execHistoryLoading = false
        this.execHistory.data = []
        this.execHistory.count = 0
        this.execHistory.error = true
        this.$Notice.error({ title: '获取执行记录数据失败' })
      })
    },
    // 获取脚本执行记录详情
    getExecLogDetail (id) {
      this.execLogDetail = {}
      detailScriptExecLogs(id).then(res => {
        this.execLogDetail = res.data
        this.execLogDetailModal = true
      }).catch(res => {
        this.$Notice.error({ title: '获取执行记录详情数据失败' })
      })
    },
    // 获取版本历史记录
    getVersionHistory (value = 1) {
      this.versionHistory.page = value
      let params = {
        size: this.versionHistory.size,
        page: this.versionHistory.page,
        script: this.$route.params.id
      }
      getScriptVersionHistory(params).then(res => {
        this.versionHistory.data = res.data.results
        this.versionHistory.count = res.data.count
      }).catch(res => {
        this.versionHistory.data = []
        this.versionHistory.count = 0
        this.versionHistory.error = true
        this.$Notice.error({ title: '获取版本历史数据失败' })
      })
    },
    getJson (data) {
      return getJsonFun(data)
    },
    // 监听WS消息
    listener () {
      this.$options.sockets.onmessage = (data) => {
        const fData = JSON.parse(data.data)
        if (fData.group === 'message' && fData.service === 'opscenter' && fData.module === 'script') {
          if (fData.data) {
            if (fData.data.script_id + '' === this.$route.params.id + '') {
              this.getExecLogs(this.execHistory.page)
            }
            if (fData.data.script_log_id === this.execLogDetail.id && this.execLogDetailModal === true) {
              this.getExecLogDetail(this.execLogDetail.id)
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="less">
  @import './base.less';
  .ivu-poptip-body {
    text-align: left !important;
  }
  .logs-scroll-bar {
    height: 750px;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
  .span-dt {
    font-weight: bold;
  }
  .exec-logs-detail-c {
    font-size: 15px
  }
  .exec-logs-detail-c .ivu-row {
    line-height: 25px;
  }
  @media screen and (max-width:640px){
    .content .main .info-property dl dt{
      width:80px;
    }
  }
</style>
